import axios from "axios";
import { store } from "@services/StateManagement/Store";

export const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SYS_API_URL,
});

export const sendRegisterDeviceRequest = async (
  deviceRegistrationId: string = "",
  tenantCode: string = "",
) => {
  const header = store.getState().api.headers;
  api.defaults.headers = header;

  try {
    const response = await api.post(
      "v1/devices/register",
      { device_registration_id: deviceRegistrationId, tenant_code: tenantCode },
      { responseType: "blob" },
    );

    const contentType = response.headers["content-type"];
    if (contentType?.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { error: json.error || "エラーが発生しました。" };
    }

    const p12Password = response.headers["x-p12-password"];

    const blob = new Blob([response.data], { type: "application/x-pkcs12" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${tenantCode}_認証証明_${new Date().toISOString()}.p12`;
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);

    return { p12Password };
  } catch (error: any) {
    let errorMessage = "クライアント証明書のダウンロードに失敗しました。";
    if (error.response?.status === 422) {
      errorMessage =
        "認証証明発行は無効です。テナントのセキュリティ設定を確認してください。";
    }
    return { error: errorMessage || error.message || "エラーが発生しました。" };
  }
};
